export const brochures = {
label: 'Folletos de Productos',
page_title: 'Folletos de Productos',
page_subtitle: 'Acceda a los folletos oficiales de productos de One More Global Inc. en inglés y español.',
section_title: 'Folletos de Productos',
section_description: 'Descargue o vea nuestros folletos oficiales de productos en inglés y español.',

// English Brochure
en_card_title: 'English Product Brochure',
en_card_description: 'View the full product catalog from One More Global Inc. in English.',
en_button: 'Open English Brochure',

// Spanish Brochure
es_card_title: 'Folleto de Productos en Español',
es_card_description: 'Consulta el catálogo oficial de productos de One More Global Inc. en español.',
es_button: 'Abrir Folleto en Español',
};
